export default "/_next/static/images/75727d784c77a349417fde21c922571c.jpg";